import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FaInstagram, FaWhatsapp, FaEnvelope } from "react-icons/fa";
import { Phone, MapPin } from "lucide-react";

export default function Footer() {
  const legalLinks = [
    { label: "Aydınlatma Metni", href: "/aydinlatma-metni" },
    { label: "Kullanım Şartları", href: "/kullanim-sartlari" },
    { label: "KVKK", href: "/kvkk" },
    { label: "Gizlilik Politikası", href: "/gizlilik-politikasi" },
  ];

  const hizmetLinks = [
    { label: "Hakkımda", href: "/hakkimda" },
    { label: "Çalışma Alanları", href: "/calisma-alanlari" },
    { label: "Seans Süreci", href: "/hizmetlerimiz" },
    { label: "Blog", href: "/blog" },
    { label: "Videolar", href: "/videolar" },
    { label: "Eğitimler", href: "/egitimler" },
    { label: "S.S.S", href: "/sss" },
    { label: "İletişim", href: "/iletisim" },
    { label: "Randevu Al", href: "/randevu-al" },
  ];

  const socialLinks = [
    {
      icon: <FaInstagram />,
      href: "https://www.instagram.com/uzm.klnk.psk.aysunseremet/",
      label: "Instagram",
    },
    {
      icon: <FaWhatsapp />,
      href: "https://wa.me/905372153407",
      label: "WhatsApp",
    },
    {
      icon: <FaEnvelope />,
      href: "mailto:info@aysunseremet.com",
      label: "E-posta",
    },
  ];

  return (
    <motion.footer
      className="bg-gray-900 border-t border-gray-200 px-6 pt-14 pb-8"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: false, amount: 0.2 }}
      transition={{ duration: 0.5 }}
    >
      <div className="mx-auto max-w-6xl">
        {/* Üst: 4 sütun */}
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {/* Marka */}
          <div>
            <h3 className="text-base font-semibold text-white">
              Uzm. Klinik Psikolog Aysun Şeremet
            </h3>
            <p className="mt-3 text-sm leading-6 text-gray-400">
              Antalya'da online ve yüz yüze psikolojik danışmanlık.
              Yetişkin, Çocuk-Ergen, Aile Terapisi ve Kurumsal Destek.
            </p>
            <div className="mt-4 space-y-2 text-sm text-gray-400">
              <a
                href="tel:+905372153407"
                className="flex items-center gap-2 hover:text-white"
              >
                <Phone className="h-4 w-4" />
                0537 215 34 07
              </a>
              <div className="flex items-center gap-2">
                <MapPin className="h-4 w-4" />
                Antalya, Türkiye
              </div>
            </div>
          </div>

          {/* Hizmet / Menü */}
          <div>
            <h3 className="text-sm font-semibold text-white">Kurumsal</h3>
            <ul className="mt-3 space-y-2 text-sm">
              {hizmetLinks.map((l) => (
                <li key={l.href}>
                  <Link
                    to={l.href}
                    className="text-gray-400 transition hover:text-white"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Yasal + Sosyal */}
          <div>
            <h3 className="text-sm font-semibold text-white">Yasal</h3>
            <ul className="mt-3 space-y-2 text-sm">
              {legalLinks.map((l) => (
                <li key={l.href}>
                  <Link
                    to={l.href}
                    className="text-gray-400 transition hover:text-white"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>

            <h3 className="mt-6 text-sm font-semibold text-white">Takip Et</h3>
            <div className="mt-3 flex items-center gap-4 text-lg">
              {socialLinks.map((s) => (
                <motion.a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  whileHover={{ scale: 1.12 }}
                  whileTap={{ scale: 0.95 }}
                  className="text-gray-400 transition hover:text-white"
                >
                  {s.icon}
                </motion.a>
              ))}
            </div>
          </div>
        </div>

        {/* Alt copyright */}
        <div className="mt-10 border-t border-gray-800 pt-6 text-center text-xs text-gray-500">
          © {new Date().getFullYear()} Uzman Klinik Psikolog Aysun Şeremet. Tüm
          hakları saklıdır. |{" "}
          <a
            href="https://aysunseremet.com"
            className="hover:text-gray-300"
          >
            aysunseremet.com
          </a>
        </div>
      </div>
    </motion.footer>
  );
}
